import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  AuthUser,
  CreateUser,
  FindManyUsers,
  FindOne,
  Option,
  PaginateResult,
  ResetPassword,
  UpdateUser,
  User,
} from '@univacity/shared/types';
import { ObjectUtil } from '@univacity/shared/util';
import { Observable, map } from 'rxjs';
import { Configuration } from '../config/configuration';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  baseUrl: string;

  constructor(private http: HttpClient, private config: Configuration) {
    this.baseUrl = this.config.apiMainUrl + '/auth/user';
  }
  findUser(query?: FindManyUsers): Observable<PaginateResult<AuthUser>> {
    const params = new HttpParams({
      fromObject: query as Params,
    });
    return this.http.get<PaginateResult<AuthUser>>(this.baseUrl, {
      params,
    });
  }
  findByGroup(
    groupId: string,
    query?: FindManyUsers
  ): Observable<PaginateResult<AuthUser>> {
    const params = new HttpParams({
      fromObject: query as Params,
    });
    return this.http.get<PaginateResult<AuthUser>>(
      `${this.baseUrl}/group/${groupId}`,
      { params }
    );
  }

  count(query: FindManyUsers = {}) {
    const params = new HttpParams({
      fromObject: query as Params,
    });
    return this.http.get<number>(`${this.baseUrl}/count`, {
      params,
    });
  }
  findOne(id: string, query: FindOne = {}) {
    const params = new HttpParams({
      fromObject: query as Params,
    });
    return this.http.get<AuthUser>(`${this.baseUrl}/${id}`, {
      params,
    });
  }
  fetchProfile() {
    return this.http.get<AuthUser>(`${this.baseUrl}/profile`);
  }

  fetchUserProfile(user: string) {
    return this.http.get<AuthUser>(`${this.baseUrl}/profile/public/${user}`);
  }

  create(body: CreateUser): Observable<AuthUser> {
    return this.http.post<AuthUser>(
      this.baseUrl,
      ObjectUtil.removeEmptyProperties(body)
    );
  }

  update(userID: string, body: UpdateUser): Observable<AuthUser> {
    return this.http.patch<AuthUser>(
      `${this.baseUrl}/${userID}`,
      ObjectUtil.removeEmptyProperties(body)
    );
  }
  updateProfile(user: UpdateUser) {
    return this.http.patch<AuthUser>(
      `${this.baseUrl}/profile`,
      ObjectUtil.removeEmptyProperties(user)
    );
  }

  delete(userId: string) {
    return this.http.delete(`${this.baseUrl}/${userId}`);
  }

  resetPassword(body: ResetPassword) {
    return this.http.post(`${this.baseUrl}/reset/password`, body);
  }
  autoComplete = (
    search: string,
    page?: number,
    query: FindManyUsers = {}
  ): Observable<{ options: Option[]; nextPage?: number | null }> => {
    const params = ObjectUtil.removeEmptyProperties({
      ...query,
      search,
      page,
      select: ['firstName', 'lastName'],
    });
    return this.http
      .get<PaginateResult<User>>(this.baseUrl, {
        params,
      })
      .pipe(
        map((res) => {
          const options: Option[] = res.docs.map((i) => ({
            label: i.firstName + ' ' + i.lastName,
            value: i._id,
          }));
          return { options, nextPage: res.nextPage };
        })
      );
  };
}
